/**
 * Change styles to search results page.
 */
function initSearchResultsPage() {
   const searchButtonSite = document.querySelector('#searchSpan');
    const searchInputSite = document.querySelector('#searchInput');

    function searchSite(event) {
        event.preventDefault();
        // Get the search term from the input field
        const searchT = searchInputSite.value;
        // Encode the search term for URL
        const encodedSearchT = encodeURIComponent(searchT);
        // Clean up the search params
        const url = new URL(window.location.href);
        // Remove the search part from the URL
        url.search = '';
        window.location.href = `${url}?q=${encodedSearchT}`.replace(/\/\?/, "?");
    }

    if (searchButtonSite && searchInputSite) {
        searchButtonSite.addEventListener('click', (e) => {
            searchSite(e);
        });

        searchInputSite.addEventListener('keypress', (e) => {
            if (e.key === "Enter") {
                searchSite(e);
            }
        })
    }
}
initSearchResultsPage();
export default initSearchResultsPage;